import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation, useParams } from "react-router-dom";
import { FaHome, FaFolder, FaFileAlt, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../auth/Logout"; // adjust path as needed
import logo from "../../../assets/irc-logo-rb.png";
import "./Document.css";
import Sidebar from "../shared/Sidebar";

const Document = () => {
  const [documents, setDocuments] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const handleToggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/get_documents.php`
        );

        if (response.data.success) {
          setDocuments(response.data.documents);
        } else {
          console.error("Failed to fetch documents:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  return (
    <div className="document-page">
      <Sidebar onHomeClick={handleToggleSidebar} />
      <div className="document-content-center">
        <h1>Documents disponibles</h1>
        {loading ? (
          <p>Chargement des documents...</p>
        ) : documents.length > 0 ? (
          <div className="document-table-container">
            <table className="document-table">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Description</th>
                  <th>Fichier</th>
                </tr>
              </thead>
              <tbody>
                {documents.map((doc) => (
                  <tr key={doc.id}>
                    <td className="doc-title">{doc.titre}</td>
                    <td className="doc-desc">{doc.description}</td>
                    <td className="doc-link">
                      <a
                        href={doc.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {doc.name}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Aucun document disponible.</p>
        )}
      </div>
    </div>
  );
};

export default Document;
